import React, { useState } from "react";
import { HiMinus, HiPlus } from "react-icons/hi";
import "./singleaccordion.css";

const SingleAccordion = ({ title, info }) => {
  const [showInfo, setShowInfo] = useState(false);
  return (
    <article className="question">
      <header>
        <h4>{title}</h4>
        <button className="btn-nobs" onClick={() => setShowInfo(!showInfo)}>
          {showInfo ? <HiMinus /> : <HiPlus />}
        </button>
      </header>
      {showInfo && <p>{info}</p>}
    </article>
  );
};

export default SingleAccordion;
